module.exports = __webpack_public_path__ + "static/media/marketing.8263bac2.png";